const spacingValues = {
    none: '0px',
    'x-small': '4px',
    small: '8px',
    medium: '16px',
    large: '24px',
    'x-large': '32px',
    'xx-large': '40px',
};
class SpacingProps {
    constructor(top, bottom, left, right) {
        this.top = top;
        this.bottom = bottom;
        this.left = left;
        this.right = right;
    }
    applySpacingStyles(element) {
        const style = element.style;
        if (this.top) {
            style.marginTop = spacingValues[this.top];
        }
        if (this.bottom) {
            style.marginBottom = spacingValues[this.bottom];
        }
        if (this.left) {
            style.marginLeft = spacingValues[this.left];
        }
        if (this.right) {
            style.marginRight = spacingValues[this.right];
        }
    }
}

function applyProps(element, props) {
    props.applySpacingStyles(element);
}
function applySpacingProps(el, top, bottom, left, right) {
    const spacingProps = new SpacingProps(top, bottom, left, right);
    applyProps(el, spacingProps);
}

export { applySpacingProps as a };
